import { securedAxiosInstance } from "../axios";

class DiscountsService {
  fetch(storeId) {
    return securedAxiosInstance.get(`/stores/${storeId}/discount`);
  }
}

export default new DiscountsService();
